import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {

	return {
		resultsContainer: {
			borderRadius   : theme.other.borderRadius,
			padding        : "2rem 0",
			display        : "flex",
			flexDirection  : "column",
			minHeight      : "600px",
			width          : "100%",
			maxWidth       : "1000px",
			justifyContent : props?.loader || !props?.dataFlag ? "center" : "flex-start",

			[rooterMediaQuery.mobileAndTablet]: {
				borderRadius: "unset"
			}
		},
		imageLoaderWrapper: {
			width    : "100%",
			display  : "flex",
			flexWrap : "wrap",
			padding  : "2rem",
			gap      : "1rem"
		},
		reelContainer: {
			margin: "2rem 0",

			[rooterMediaQuery.mobileAndTablet]: {
				margin: "2rem"
			}
		}
	};
} );

